<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { _ } from "svelte-i18n";
    import RouteplannerRow from "./RouteplannerRow.svelte";
    import type { ReRouteData } from "../../api/projects/data/reroute/ReRouteData";
    import type { ProjectAndScenariosData } from "../../api/projects/data/projects/ProjectAndScenariosData";
    import {appManager} from "../../AppManager";

    export let reroutes: ReRouteData[];
    export let project: ProjectAndScenariosData;

    let url: string = `${appManager.PublicUrl}project/${project.id}/routeplanners`;

    const dispatch = createEventDispatcher();
</script>

<div class="card card-bleed shadow-light-lg">
    <div class="card-header">
        <div class="row align-items-center">
            <div class="col">
                <h4 class="mb-0"><a href={url}>Route planners</a></h4>
            </div>
            <div class="col-auto">
                <button
                    class="btn btn-xs btn-primary ms-auto"
                    on:click={() => {
                        dispatch("create");
                    }}>
                    {$_("impact.project.routeplanner.new")}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="list-group list-group-flush">
            {#if reroutes?.length === 0}
                {$_("impact.project.routeplanner.empty")}
            {:else}
                {#each reroutes as reroute, i}
                    <RouteplannerRow
                        {project}
                        {reroute}
                        on:removed={() => {
                            dispatch("removed");
                        }}
                        on:publish={() => {
                            dispatch("publish");
                        }} 
                        on:scenarios={() => {
                            dispatch("scenarios");
                        }} />
                {/each}
            {/if}
        </div>
    </div>
</div>
